import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Container, Row } from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
//Import Breadcrumb
import Breadcrumbs from "../../components/Breadcrumb"
// Pages Components
import WelcomeComp from "./WelcomeComp"
import InfoComp from "./InfoComp"
// import PlanComp from "./PlanComp"
import GraphComp from "./GraphComp"
import PageLoader from "../../components/Loaders/pageLoader"
import { getDashboardInfo, getDashboardInfoFilter, getMedianAndAverage } from "../../store/dashboard/actions"
import { allowedDepartments } from '../../helpers/currency_helper';

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }
  componentDidMount() {
    const { onGetDashboardInfo } = this.props
    onGetDashboardInfo(this.props.profileData._id)
  }
  
  render() {
    const { profileData, loading } = this.props
    console.log(this.props)
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className="page-content">
          <MetaTags>
            <title>Dashboard </title>
          </MetaTags>
          <Container fluid className="pe-4">
            <Breadcrumbs title="Dashboards" breadcrumbItem="Dashboard" />
            <WelcomeComp props={this.props} />
            {allowedDepartments.includes(profileData.department.depName) && (
              <>
              <Row>
                <InfoComp props={this.props} />
              </Row>
              <Row>
                <GraphComp props={this.props} />
              </Row>
              </>
            )} 
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

Dashboard.propTypes = {
  dashboard: PropTypes.array,
  onGetDashboardInfo: PropTypes.func,
}

const mapStateToProps = ({ dashboard }) => ({
  date: dashboard.date,
  period: dashboard.period,
  periodFrames: dashboard.periodFrames,
  curInfo: dashboard.curInfo,
  pastInfo: dashboard.pastInfo,
  countryStats: dashboard.countryStats,
  clientsStats: dashboard.clientsStats,
  weeklyData: dashboard.weeklyData,
  weeksRange: dashboard.weeksRange,
  title: dashboard.title,
  median: dashboard.median,
  avg: dashboard.avg,
  loading: dashboard.loading,
})

const mapDispatchToProps = dispatch => ({
  // onGetDashboardDate: () => dispatch(getDashboardDate()),
  onGetDashboardInfo: id => dispatch(getDashboardInfo(id)),
  onGetDashboardInfoFilter: id => dispatch(getDashboardInfoFilter(id)),
  onGetMedianAndAverage: id => dispatch(getMedianAndAverage(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Dashboard))
